import { composeIO } from 'react-compose-io'
import { cabecalhoInadimplenciaIO } from './CabecalhoInadimplencia.IO'
import { CabecalhoInadimplenciaView } from './CabecalhoInadimplencia.View'

export const CabecalhoInadimplencia = composeIO(CabecalhoInadimplenciaView, cabecalhoInadimplenciaIO)
